module.exports = __webpack_public_path__ + "img/vi.be0b76d9.png";